const languages = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "ru", name: "Русский", flag: "🇷🇺" },
  { code: "ge", name: "ქართული", flag: "🇬🇪" },
  { code: "ar", name: "العربية", flag: "🇦🇪" },
];

export { languages };
